var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.state.isLoading)?_c('div',{class:_vm.vueAppClasses,attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath,class:`route-${_vm.$route.name}`,on:{"setAppClasses":_vm.setAppClasses}}),(_vm.$route.name && !_vm.$route.meta.mobileEnabled)?_c('MobileDisabled'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }